import React, { useEffect, useState } from 'react'
import styled from 'styled-components';

import { useTranslate } from '@tolgee/react';
import ContactsList from './ContactsList';
import AddNewChatContact from './AddNewContact';
import IconButton from '../GenericComponents/IconButton';
import { ReactComponent as AddContact } from "../../Assets/iconsv2/generic/addContact.svg"
import ContactDetailsView from './ContactDetails';
import { cloneDeep } from 'lodash';


const Contacts = ({ loadContacts, contacts, inviteAction, callAction, chatAction, blockAction, unblockAction }) => {

    const [isAddNewContactOpen, setIsAddNewContactOpen] = useState(false);
    const [isContactDetailsOpen, setIsContactDetailsOpen] = useState(null);

    const changeContactBlockState = (item, isBlocked) => {
        let newContact = cloneDeep(item);
        setIsContactDetailsOpen({
            ...newContact,
            blocked: isBlocked
        })
    }

    const handleBlock = (item) => {
        blockAction(item,
            () => {
                loadContacts();
                changeContactBlockState(item, true)

            }
        )
    }
    const handleUnblock = (item) => {
        unblockAction(item,
            () => {
                loadContacts();
                changeContactBlockState(item, false)

            }
        )
    }

    const handleOpenAddNewContact = () => {
        setIsAddNewContactOpen(!isAddNewContactOpen)
        if (isContactDetailsOpen) {
            setIsContactDetailsOpen(null)
        }
    }

    const containerClickAction = (item) => {
        setIsContactDetailsOpen(item)
        if (isAddNewContactOpen) {
            setIsAddNewContactOpen(false)
        }
    }

    const closeContactDetailsView = () => {
        setIsContactDetailsOpen(null)
    }

    useEffect(() => {
        loadContacts()
    }, [])
    const { t } = useTranslate();
    return (
        <Container>
            <Main>
                <Header>
                    <HeaderTitle>{t('general.contacts')}</HeaderTitle>
                    <IconButton
                        onClick={handleOpenAddNewContact}
                        icon={<AddContact />}
                    />
                </Header>
                <ContactsList
                    contacts={contacts}
                    inviteAction={inviteAction}
                    callAction={callAction}
                    chatAction={chatAction}
                    containerClickAction={containerClickAction}
                />
            </Main>
            <Details>
                {isAddNewContactOpen &&
                    <AddNewChatContact
                        closeAction={() => setIsAddNewContactOpen(false)}
                        loadContacts={loadContacts}
                    />
                }
                {isContactDetailsOpen &&
                    <ContactDetailsView
                        contact={isContactDetailsOpen}
                        closeAction={closeContactDetailsView}
                        callAction={callAction}
                        chatAction={chatAction}
                        handleUnblockContact={handleUnblock}
                        handleBlockContact={handleBlock}
                    />

                }

            </Details>
        </Container>


    )
}

export default Contacts

const Container = styled.div`
display:flex;
width:100%;

`

const Main = styled.div`
display:flex;
flex-direction:column;
max-width:419px;
min-width:419px;
width:100%;
background:${({ theme }) => theme.menu.background};
border-right:1px solid ${({ theme }) => theme.sidebar.borderColor};
overflow:hidden;
`
const Header = styled.div`
display:flex;
justify-content:space-between;
padding: 19px 16px;
align-items:center;
background:${({ theme }) => theme.menu.background};
border-bottom:1px solid ${({ theme }) => theme.sidebar.borderColor};
gap:20px;
`
const HeaderTitle = styled.h3`
font-weight: 700;
font-size: 20px;
line-height:32px;
letter-spacing: 0.04px;
color:${({ theme }) => theme.menu.primaryTextColor};
`

const Details = styled.div`
width:100%;
display:flex;
background:${({ theme }) => theme.menu.background};
`
